export default function XSD_Example() {
  return (
    <div>
      <h1>XSD_Example</h1>
      <p>This is the XSD_Example component.</p>
    </div>
  );
}